import { render, staticRenderFns } from "./DynamicBreadCrumb.vue?vue&type=template&id=3fba429a&scoped=true&"
import script from "./DynamicBreadCrumb.vue?vue&type=script&lang=js&"
export * from "./DynamicBreadCrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba429a",
  null
  
)

export default component.exports